export const interfaceEn = {
  "Asymmetric meshes": "Asymmetric meshes",
  "Retry PDF preview": "Retry PDF preview",
  "Choose PDF language": "Choose PDF language",
  "Preparing PDF": "Preparing PDF…",
  "PDF generation failed": "Could not generate the PDF. Please try again.",
  "Cancel PDF download": "Cancel",

  "Loading PDF page": "Loading PDF page…",
  "PDF page could not be displayed": "The page could not be displayed. You can download the PDF or try another page.",
  "Enter Company Name": "Enter Company Name",
  "Enter Your Last Name": "Enter Your Last Name",
  "Enter Your Phone Number": "Enter Your Phone Number",
  "Enter Your Email": "Enter Your Email",
  "Enter Your Password": "Enter Your Password",
  "Enter Your Job Title": "Enter Your Job Title",
  "Enter Your First Name": "Enter Your First Name",
  "Phone number must be 9 or 10 digits": "Phone number must be 9 or 10 digits",
  "Generating PDF": "Generating PDF",
  "Type your full name": "Type your full name",
  "Type your phone number": "Type your phone number",
  "Type your job": "Type your job",
  "Loading...": "Loading...",
  "Company": "Company",
  "create new": "create new",
  "Edit": "Edit",
  "Add New": "Add New",
  "project": "project",
  "creator": "creator",
  "create a user": "create a user",
  "Your": "Your",
  "order has been successfully saved.": "order has been successfully saved.",
  "What’s next?": "What’s next?",
  "go to my orders": "go to my orders",
  "create a new order": "create a new order",
  "(NIS)": "(NIS)",
  "NIS": "NIS",
  "Price": "Price",
  "Total": "Total",
  "Price (NIS)": "Price (NIS)",
  "Suppliers Prices": "Suppliers Prices",
  "You can enter the prices of your supplier, and see the costs of each item in the document. This way you can also avoid mistakes easily.": "You can enter the prices of your supplier, and see the costs of each item in the document. This way you can also avoid mistakes easily.",
  "* Required field to see price line": "* Required field to see price line",
  "Suppliers": "Suppliers",
  "Choose your supplier": "Choose your supplier",
  "Price List": "Price List",
  "Rebars": "Rebars",
  "Price per ton": "Price per ton",
  "Cuts": "Cuts",
  "Bending": "Bending",
  "Extra for 2D hoops": "Extra for 2D hoops",
  "Nets": "Nets",
  "Standard Nets": "Standard Nets",
  "Special Nets": "Special Nets",
  "Extra for bending nets": "Extra for bending nets",
  "Pile cages": "Pile cages",
  "Symmetrical standard pile cage": "Symmetrical standard pile cage",
  "Special pile cage": "Special pile cage",
  "Extra for Gama pile / Diameter: 2 inch": "Extra for Gama pile / Diameter: 2 inch",
  "Extra for Gama pile / Diameter: 2.5 inch": "Extra for Gama pile / Diameter: 2.5 inch",
  "cancel": "cancel",
  "save": "save",
  "Select Type": "Select Type",
  "Previous PDF page": "Previous PDF page",
  "Next PDF page": "Next PDF page",
  "Close PDF preview": "Close PDF preview",
  "Duplicating order...": "Duplicating order...",
  "This may take a few seconds.": "This may take a few seconds.",
  "Do not close or refresh this page.": "Do not close or refresh this page.",
  "Order duplicated successfully": "Order duplicated successfully",
  "A new copy was created. Stay in the order list or edit the new order.": "A new copy was created. Stay in the order list or edit the new order.",
  "New order number": "New order number",
  "Stay in orders": "Stay in orders",
  "Edit new order": "Edit new order",
  "Copy order number": "Copy order number",
  "Duplicate order": "Duplicate order",
  "Business ID": "Business ID",
  "New": "New",
  "Select company": "Select company",
  "Search by company name": "Search by company name",
  "Add new company": "Add new company",
  "No matching companies": "No matching companies",
  "Heading": "Heading",
  "Use a heading to separate elements": "Use a heading to separate elements",
  "Notes to supplier": "Notes to supplier",
  "Packaging, markings, welding and other notes...": "Packaging, markings, welding and other notes...",
  "Save and lock heading": "Save and lock heading",
  "Heading options and dragging": "Heading options and dragging",
  "Options and dragging": "Options and dragging",
  "Delete": "Delete",
  "Heading:": "Heading:",
  "Notes to supplier:": "Notes to supplier:",
  "Add heading": "Add heading",
  "Send to factory": "Send to factory",
  "Processing and waste": "Processing and waste",
  "Cutting (kg)": "Cutting (kg)",
  "Bending (kg)": "Bending (kg)",
  "Units": "Units",
  "Waste 3% (tons)": "Waste 3% (tons)",
  "Total including waste (tons)": "Total including waste (tons)",
  "Diameters": "Diameters",
  "Total sum": "Total sum",
  "Length (m)": "Length (m)",
  "Weight (kg)": "Weight (kg)",
  "Order": "Order",
  "Bars": "Bars",
  "Standard meshes": "Standard meshes",
  "Piles": "Piles",
  "Weight (tons)": "Weight (tons)",
  "Recipient email": "Recipient email",
  "Notes": "Notes",
  "Optional email message": "Optional email message",
  "Factory name": "Factory name",
  "Enter factory name": "Enter factory name",
  "Factory email": "Factory email",
  "Date": "Date",
  "User": "User",
  "Changes": "Changes",
  "Polygonal steel | Diameters: 8-25 mm": "Polygonal steel | Diameters: 8-25 mm",
  "Polygonal steel | Diameters: 28-36 mm": "Polygonal steel | Diameters: 28-36 mm",
  "Round steel | Diameters: 6-12 mm": "Round steel | Diameters: 6-12 mm",
  "Round steel | Diameters: above 12 mm": "Round steel | Diameters: above 12 mm",
  "Extra for Gama pile | Diameter: 2 inch": "Extra for Gama pile | Diameter: 2 inch",
  "Extra for Gama pile | Diameter: 2.5 inch": "Extra for Gama pile | Diameter: 2.5 inch"
};
